<template>
    <b-card no-body>
        <!-- Card header -->
        <b-card-header>
            <!-- Title -->
            <h5 class="h3 mb-0">Mockups</h5>
        </b-card-header>

        <!-- Card body -->
        <b-card-body>
            <div class="loader" v-if="loading"></div>

            <!-- List group -->
            <b-list-group flush class="list my--3">
                <b-list-group-item v-for="mockup in mockupsList"
                    :key="mockup.id"
                    class="list-group-item px-0">
                    <b-row align-v="center" class="mx-2">
                        <b-col cols="auto" class="p-0">
                            <a href="#" class="mockup-preview d-block">
                                <b-img alt="Mockup preview" :src="mockup.thumb" />
                            </a>
                        </b-col>
                        <b-col class="px-3">
                            <h4 class="mb-0">
                                <a href="#!">Mockup No. {{ mockup.pos }}</a>
                            </h4>
                            <span :class="`text-${mockup.state}`"></span>
                            <small>{{ mockup.created_at }}</small>
                        </b-col>
                        <b-col cols="auto" class="p-0">
                            <a :href="'#/artist/mockup/'+mockup.id" class="btn btn-sm btn-dark" @click="downloadMockup(mockup.id)">Download</a>
                        </b-col>
                    </b-row>
                </b-list-group-item>
            </b-list-group>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from 'moment'

export default {
    name: "mockups",
    data() {
        return {
            loading: false,
            mockupsList: [],
            downloadLoading: false,
        };
    },
    props: {
        photoBookId: '',
    },
    methods: {
        retrieveMockups() {
            this.loading = true;
            this.$api.
            getPhotoBookImages(this.photoBookId, {imagetype: "mockup"})
                .then((response) => {
                    this.mockupsList = response.data.photo_book_images;
                    console.log("Mockups loaded:", this.mockupsList);
                })
                .catch((e) => {
                    console.log("Error loading mockups:", e);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        
        formatDate(date) {
            return moment(date).format("Do MMM YYYY");
        },

            async downloadMockup(imageId) {
            try {
                this.downloadLoading = true;
                const response = await this.$api.getPhotoBookImageOriginal(this.photoBookId, imageId);
                
                // Create blob from response
                const blob = new Blob([response], { type: response.type });
                
                // Create a temporary link and trigger download
                let title = "mockup_"+imageId+".jpg"
                console.log(title)
        const url = window.URL.createObjectURL(new Blob([response]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', title)
        document.body.appendChild(link)
        link.click()


/*

                console.log(title)
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', title)
        document.body.appendChild(link)
        link.click()

*/

            } catch (error) {
                console.error('Error downloading mockup:', error);
                alert('Failed to download mockup. Please try again.');
            } finally {
                this.downloadLoading = false;
            }
        },
    },
    computed: {
        ...mapGetters({ currentAccount: 'currentAccount' }),
        mockupsLoaded() {
            return this.mockupsList ? true : false;
        }
    },
    mounted() {
        this.retrieveMockups();
    },
};
</script>

<style scoped>
.avatar {
    display: block;
    padding: 0.5rem;
    width: 120px;
}

.mockup-preview {
    display: block;
    padding: 0.25rem;
    width: 120px;
}

.mockup-preview img {
    width: 100%;
    height: 100px;
    object-fit: contain;
    border-radius: 0.375rem;
}

.list-group-item {
    transition: all 0.2s ease;
    border-left: 0;
    border-right: 0;
}

.list-group-item:hover {
    background-color: transparent;
}
</style>